export default __webpack_public_path__ + "static/lframe-motor-bike-loan-f1ef25b230ad27dc5bb2a1dc02bfea8e.png";